<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Modal, Container, Stack, AdvancedCard, Button } from '@Shelly/shelly-design-system';

	export let showModal = false;

	const dispatch = createEventDispatcher();

	const handleCreateCondition = () => {
		dispatch('create');
	};

	const handleImportCondition = () => {
		dispatch('import');
	};

	const handleClose = () => {
		showModal = false;
		dispatch('close');
	};
</script>

<Modal
	title={$format('choose_condition_type', { default: 'Choose condition type' })}
	bind:showModal
	on:close={handleClose}
	size="m"
>
	<Container padding="0" slot="content">
		<Stack gap="m">
			<AdvancedCard
				avatar={{
					icon: 'fas fa-plus-circle',
				}}
				title={$format('create_condition', { default: 'Create condition' })}
				on:click={handleCreateCondition}
				interactive
				isFocusable
				aria-label={$format('create_condition', { default: 'Create condition' })}
			/>
			<AdvancedCard
				avatar={{
					icon: 'fas fa-file-import',
				}}
				title={$format('import_condition', { default: 'Import condition' })}
				on:click={handleImportCondition}
				interactive
				isFocusable
				aria-label={$format('import_condition', { default: 'Import condition' })}
			/>
		</Stack>
	</Container>

	<div slot="footer" class="d-flex justify-content-end width-full">
		<Button variant="secondary" on:click={handleClose}>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
	</div>
</Modal>
